import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from "react";
import { DYNAMIC_PROCESS_TABS } from "./dynamic-process-tabs-enum";

type ContextProps = {
  step: DYNAMIC_PROCESS_TABS;
  setStep: Dispatch<SetStateAction<DYNAMIC_PROCESS_TABS>>;
};

const TabsContext = createContext<ContextProps | null>(null);

type TabsContextProviderProps = {
  children: ReactNode | ((props: ContextProps) => ReactNode);
};

export function TabsContextProvider({ children }: TabsContextProviderProps) {
  const [step, setStep] = useState(DYNAMIC_PROCESS_TABS.BASE_KEY);

  return (
    <TabsContext.Provider value={{ step, setStep }}>
      {typeof children === "function" ? children({ step, setStep }) : children}
    </TabsContext.Provider>
  );
}

export function useTabs() {
  const ctx = useContext(TabsContext);

  if (ctx === null) {
    throw new Error("useTabs must be used within a TabsContextProvider");
  }

  return ctx;
}
